import _ from 'lodash';
import React from 'react';
import posed from 'react-pose';
import styles from './GameEndPicture.module.scss';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses} from '../gameHelpers';
import {easing} from 'popmotion';

const Container = posed.div({
    result: {
        y: 0,
        transition: {ease: 'easeOut', delay: 500, duration: 1500},
    },
    ...keysToSingleValue(_.without(allPoses, 'result'), {
        y: '100vh',
    }),
});

const Picture = posed.div({
    result: {
        rotate: 0,
        transition: {
            rotate: {
                type: 'keyframes',
                times: [0, 0.25, 0.5, 0.75, 1],
                values: [0, 8, 0, -8, 0],
                easings: [easing.easeOut, easing.easeIn, easing.easeOut, easing.easeIn],
                duration: 1200,
                loop: 1,
            },
        },
    },
});

export default function GameEndPicture() {
    return (
        <Container className={styles.container}>
            <Picture className={styles.picture} />
        </Container>
    );
}
